import { Button } from "@ui/Button"

export default function SlotPicker({ slots, onBook, booking }) {
  if (slots.length === 0) {
    return <p className="text-sm text-webex-gray-600 dark:text-webex-gray-400">No available slots for this date.</p>
  }

  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
      {slots.map((slot) => (
        <Button
          key={slot.starts_at}
          variant="secondary"
          onClick={() => onBook(slot)}
          disabled={booking}
        >
          {slot.start_time}
        </Button>
      ))}
    </div>
  )
}
